import { ProAppointment } from '../../../../api/Providers/Appointments';
import { NCDExperience } from './NCD.types';

export const checkShouldAdjudicateNCD = (
  appointment: ProAppointment | null,
  appointmentsAdjudicated: Record<number, number> = {},
  experience: NCDExperience,
): boolean => {
  if (!appointment) {
    return false;
  }

  const {
    discount_code_redemption: discountCodeRedemption,
    has_ncd_fee_payment_attempt: hasNcdFeePaymentAttempt,
    is_cancelled: isCancelled,
    is_monetized_new_client_delivery: isMonetizedNewClientDelivery,
    id,
  } = appointment;

  const qualified = experience !== NCDExperience.Version1;

  const recorded = !!appointmentsAdjudicated[id];

  const shouldAdjudicate = !discountCodeRedemption
    && !hasNcdFeePaymentAttempt
    && isMonetizedNewClientDelivery
    && !isCancelled;

  return qualified && !recorded && shouldAdjudicate;
};
